$(document).click(function (e) {
	if (!$(e.target).closest('.form-result__block').length) {
		$('.form-result').fadeOut(300);
	}
	e.stopPropagation();
});



// WEBPACK FOOTER //
// ./_dev/blocks/form-result/form-result.js